const STORAGE_KEY = 'profileColor'
const STORAGE_KEY_HEX = 'profileColorHex'

export const colorPallete = [
  { name: 'teal-accent-1', hex: '#A7FFEB' },
  { name: 'green-accent-1', hex: '#B9F6CA' },
  { name: 'light-green-accent-1', hex: '#CCFF90' },
  { name: 'lime-accent-1', hex: '#F4FF81' },
  { name: 'yellow-accent-1', hex: '#FFFF8D' },
  { name: 'amber-accent-1', hex: '#FFE57F' },
  { name: 'deep-orange-accent-1', hex: '#FF9E80' },
  { name: 'red-accent-1', hex: '#FF8A80' },
  { name: 'pink-accent-1', hex: '#FF80AB' },
  { name: 'deep-purple-accent-1', hex: '#B388FF' },
  { name: 'purple-accent-1', hex: '#EA80FC' },
  { name: 'indigo-accent-1', hex: '#8C9EFF' },
  { name: 'blue-accent-1', hex: '#82B1FF' },
  { name: 'light-blue-accent-1', hex: '#80D8FF' },
  { name: 'cyan-accent-1', hex: '#84FFFF' },
]

export function getRandomBackgroundColor(): string {
  const storedColor = localStorage.getItem(STORAGE_KEY)
  if (storedColor) return storedColor

  const index = Math.floor(Math.random() * colorPallete.length)
  const color = colorPallete[index]

  localStorage.setItem(STORAGE_KEY, color.name)
  return color.name
}

export function getRandomBackgroundColorHex(): string {
  const storedColor = localStorage.getItem(STORAGE_KEY_HEX)
  if (storedColor) return storedColor

  const index = Math.floor(Math.random() * colorPallete.length)
  const color = colorPallete[index]

  localStorage.setItem(STORAGE_KEY_HEX, color.hex)
  return color.hex
}
